import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { isChannel } from "@website/utils/channel/helpers";
import { AccommodationBannerPropertiesTypes } from "@website/widget/accommodation-banner/accommodation-banner.types";
export const AccommodationBanner = properties => {
  const $ = _c(12);
  const {
    onclick,
    cityTitle
  } = properties;
  if (isChannel(["ads"])) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <MaterialIcon className="text-primary text-headline-5" name="home" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = `هنوز هتل مناسب تو ${cityTitle} پیدا نکردی؟`;
  let t2;
  if ($[1] !== t1) {
    t2 = <div className="flex flex-row items-center gap-2">{t0}<span className="text-subtitle-2">{t1}</span></div>;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="text-caption">ویلاهای با امکانات کامل و قیمت مناسب رو هم می‌تونی بررسی کنی!</span>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <div>{t2}{t3}</div>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = `مشاهده ویلاهای ${cityTitle}`;
  let t6;
  if ($[6] !== onclick || $[7] !== t5) {
    t6 = <Button className="self-end" onClick={onclick} text={t5} />;
    $[6] = onclick;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t4 || $[10] !== t6) {
    t7 = <div className="border-primary bg-transparent-primary flex w-full flex-col justify-between gap-3 rounded-xl border px-4 py-3 md:flex-row md:items-center">{t4}{t6}</div>;
    $[9] = t4;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};